import React, {useState} from "react";

function Pagination() {
  const [pageSize, setPageSize] = useState(20);

  const handlePageSize = (value) => {
    setPageSize(Number(value));
  };
  return (
    <div>
      {/* Pagination */}
      <div
        className={`border w-fit border-gray-300 border-collapse rounded text-gray-500 flex items-center opacity-100 group-hover:cursor-pointer`}
      >
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${
            pageSize === 20 ? "bg-blue-600 text-white rounded" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          20
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${
            pageSize === 100 ? "bg-blue-600 text-white" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          100
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${
            pageSize === 500 ? "bg-blue-600 text-white" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${
            pageSize === 2500 ? "bg-blue-600 text-white" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          2500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer ${
            pageSize === 5000 ? "bg-blue-600 text-white rounded" : ""
          }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          5000
        </div>
      </div>
    </div>
  );
}
export default Pagination;
